'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function AppIconNpayOff(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_AppIconNpayOff');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.39062C0 2.41347 2.41347 0 5.39062 0H18.6094C21.5865 0 24 2.41347 24 5.39062V18.6094C24 21.5865 21.5865 24 18.6094 24H5.39062C2.41347 24 0 21.5865 0 18.6094V5.39062Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9542 9.59151L17.7157 12.4946L16.3147 9.59151H15.2371L17.2224 13.6193L16.4041 15.5H17.4499L20 9.59151H18.9542ZM14.641 14.0799H13.6171V13.6607C13.2479 13.9894 12.8048 14.1714 12.2707 14.1714C11.0456 14.1714 10.0878 13.1454 10.0878 11.8357C10.0878 10.5255 11.0456 9.5 12.2707 9.5C12.8048 9.5 13.2479 9.68199 13.6171 10.0107V9.59151H14.641V14.0799ZM13.7373 11.8357C13.7373 10.9896 13.163 10.3471 12.4019 10.3471C11.6408 10.3471 11.0665 10.9891 11.0665 11.8357C11.0665 12.6817 11.6408 13.3243 12.4019 13.3243C13.163 13.3243 13.7373 12.6822 13.7373 11.8357ZM5 15.5H6.06813V13.6995C6.42831 14.0037 6.85705 14.1714 7.37025 14.1714C8.59537 14.1714 9.55321 13.1454 9.55321 11.8357C9.55321 10.526 8.59537 9.5 7.37025 9.5C6.83619 9.5 6.39304 9.68199 6.02391 10.0107V9.59151H5V15.5ZM7.2391 10.3476C8.0002 10.3476 8.5745 10.9896 8.5745 11.8362C8.5745 12.6828 8.0002 13.3248 7.2391 13.3248C6.47799 13.3248 5.90369 12.6828 5.90369 11.8362C5.90369 10.9896 6.47799 10.3476 7.2391 10.3476Z",
    fill: fill || 'black'
  })));
}
var AppIconNpayOff$1 = /*#__PURE__*/memo(AppIconNpayOff);

export { AppIconNpayOff$1 as default };
